// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import authReducer from './slices/authSlice';
import permissionsReducer from './slices/permissionsSlice';
import usersReducer from './slices/usersSlice';
import departmentsReducer from './slices/departmentsSlice';
import roleReducer from './slices/roleSlice';
import clientsReducer from './slices/clientsSlice';
import fileUploadReducer from './slices/fileUploadSlice';
import vendorReducer from './slices/vendorSlice';
import maintenanceReducer from './slices/maintenanceSlice';
import inventoryReducer from './slices/inventorySlice';
import complianceReducer from './slices/complianceSlice';
// import fieldsReducer from './slices/fieldsSlice';
// import wellsReducer from './slices/wellsSlice';
// import projectsReducer from './slices/projectsSlice';
// import reportsReducer from './slices/reportsSlice';
// import uiReducer from './slices/uiSlice';
import maintenanceArchiveReducer from './slices/maintenanceArchiveSlice';
import dashboardReducer from './slices/dashboardSlice';
import flowStationReducer from './slices/flowstationSlice';
import wellStatusReducer from './slices/wellStatusSlice';
import systemSettingsReducer from './slices/systemSettingsSlice';

export const RESET_STORE = 'RESET_STORE';

const appReducer = combineReducers({
  auth: authReducer,
  permissions: permissionsReducer,
  users: usersReducer,
  departments: departmentsReducer,
  roles: roleReducer,
  clients: clientsReducer,
  fileUpload: fileUploadReducer,
  vendors: vendorReducer,
  maintenance: maintenanceReducer,
  inventory: inventoryReducer,
  compliance: complianceReducer,
  maintenanceArchive: maintenanceArchiveReducer,
  dashboard: dashboardReducer,
  flowStation: flowStationReducer,
  wellStatus: wellStatusReducer,
  systemSettings: systemSettingsReducer,
});

type AppState = ReturnType<typeof appReducer>;

const rootReducer = (state: AppState | undefined, action: { type: string }): AppState => {
  if (action.type === RESET_STORE) {
    // Reset all slices to their initialState, but auth's initialState is evaluated
    // once at module-load time (when the user was authenticated), so passing undefined
    // would restore an authenticated snapshot instead of a clean logged-out state.
    // We override auth explicitly to guarantee the user is treated as unauthenticated.
    const resetState = appReducer(undefined, action);
    return {
      ...resetState,
      auth: {
        user: null,
        isAuthenticated: false,
        isLoading: false,
        error: null,
        resetRequestSuccess: false,
        resetRequestMessage: null,
        passwordChangeSuccess: false,
        passwordChangeMessage: null,
        passwordUpdateSuccess: false,
        passwordUpdateMessage: null,
      },
    };
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;